import { useState } from 'react';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { selectStyle } from '../SelectStyle';

const options = [
  { value: '', label: 'Всі' },
  { value: 'IN_PROGRESS', label: 'В процесі' },
  { value: 'FINISHED', label: 'Завершені' },
];

const VisitStatusSelect = ({ setVisitStatus }) => {
  const [selectedOption, setSelectedOption] = useState(options[1]);
  const isMobileView = useSelector((state) => state.screen.isMobileView);

  const handleChange = (selected) => {
    setSelectedOption(selected);
    setVisitStatus(selected.value);
  };

  return (
    <Select
      components={{
        DropdownIndicator: () => (
          <div>
            <MdKeyboardArrowDown />
          </div>
        ),
        IndicatorSeparator: () => null,
      }}
      options={options}
      className="text-xs md:text-sm w-28 md:w-36"
      value={selectedOption}
      onChange={handleChange}
      isClearable={false}
      isSearchable={false}
      styles={selectStyle(isMobileView)}
    />
  );
};

export default VisitStatusSelect;
